// extracted by mini-css-extract-plugin
export default {"root":"root--b11yL","grid":"grid--_O6P8","listItem":"listItem--xLDWi","optionsText":"optionsText--zEqKx","box":"box--Epy32","boxItems":"boxItems--QnKwF"};